import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=4b3dd67e&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&lang=ts&"
export * from "./ProductItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=4b3dd67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3dd67e",
  null
  
)

export default component.exports